import React from "react";

const GRID_COLUMNS = {
  1: "md:grid-cols-1 lg:grid-cols-1",
  2: "md:grid-cols-2 lg:grid-cols-2",
  3: "md:grid-cols-3 lg:grid-cols-3",
  4: "md:grid-cols-4 lg:grid-cols-4",
  5: "md:grid-cols-5 lg:grid-cols-5",
  6: "md:grid-cols-6 lg:grid-cols-6",
  7: "md:grid-cols-7 lg:grid-cols-7",
};

const CardShimmer = ({ count = 6, val = 3 }) => {
  const responsiveColumns = GRID_COLUMNS[val] || GRID_COLUMNS[3];

  return (
    <div className={`grid grid-cols-3 ${responsiveColumns} gap-4`}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="w-24 h-36 sm:w-32 sm:h-48 md:w-40 md:h-60 rounded-md animate-pulse bg-gray-700"
        ></div>
      ))}
    </div>
  );
};

export default CardShimmer;
